import { Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';
import { Flex, Heading } from '@betterment/style-closet-react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

import FullPageLoader from '../../Shared/components/FullPageLoader';
import { urlBuilder } from '../../Shared/urlBuilder';

const NotFound: React.FC = () => {
  // any route within /app/checking will have that basename trimmed from the pathname
  // so if the pathname includes /app, then we're out of the CheckingApp scope
  const location = useLocation();
  if (location.pathname.startsWith('/app')) {
    return <FullPageLoader />;
  }
  return (
    <Flex height="100vh" bg="white" justifyContent="center" alignItems="center">
      <Helmet>
        <title>Page not found</title>
      </Helmet>
      <Flex.Item>
        <Heading textAlign="center" fontFamily="GT America" fontSize="6">
          404
        </Heading>
        <Text
          as="p"
          css={{
            textAlign: 'center',
            marginBottom: 'space.200',
            _last: { marginBottom: 'space.0' },
          }}
        >
          The page you're looking for isn't here. Sorry about that.
        </Text>
        <Text
          as="p"
          css={{
            textAlign: 'center',
            marginBottom: 'space.200',
            _last: { marginBottom: 'space.0' },
          }}
        >
          <SambaAutoLink to={urlBuilder.getAppChecking.absolute()}>Go to Summary</SambaAutoLink>
        </Text>
      </Flex.Item>
    </Flex>
  );
};

export default NotFound;
